import { Observable } from 'rxjs/Observable';
import { TRANSLATIONS, STANDALONE_MODE } from 'settings';
import { apiService } from 'shared/services';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ITranslation, IErrorData } from 'interfaces/ITranslation';
import { enLang } from 'interfaces/IProductData';
export class TranslateService {
  private lang$ = new BehaviorSubject<enLang>(enLang.PT_BR);
  private translations$ = new BehaviorSubject<ITranslation>({
    messages: [],
    errors: {},
    texts: {}
  });

  public loadTranslations(): Observable<any> {
    if (TRANSLATIONS) {
      const translations: any = TRANSLATIONS;
      this.translations$.next(translations);
      return Observable.of(true);
    }

    const url = STANDALONE_MODE ? 'https://sun.eduzz.com/translations' : '/translations';

    return apiService
      .get(url, null, null, {
        local: true
      })
      .map(translations => {
        this.translations$.next(translations);
      });
  }

  public setLang(lang: enLang) {
    console.log('Translate', lang);
    this.lang$.next(lang);
  }

  public getTextStream(key: string): Observable<string> {
    return Observable.combineLatest(this.translations$.asObservable(), this.lang$.asObservable())
      .map(([translations, lang]) => {
        const index = `${translations.messages.indexOf(key)}`;

        if (translations.texts[lang] && translations.texts[lang][index]) {
          const textIndex = translations.texts[lang][index];
          return translations.messages[textIndex];
        }

        return key;
      })
      .distinctUntilChanged();
  }

  public getErrorData(code: string): IErrorData {
    const translations = this.translations$.value;
    const lang = this.lang$.value;

    if (!code || !code.match(/^[A-Z]{3}_[A-Z0-9]{1,2}$/) || !translations.errors[lang] || !translations.errors[lang][code]) {
      code = 'DEF_A';
    }

    const [messageIndex, titleIndex, shouldReport] = translations.errors[lang][code];

    const title = translations.messages[titleIndex];
    const message = translations.messages[messageIndex];

    return {
      code,
      title,
      message,
      shouldReport: !!shouldReport
    };
  }
}

// tslint:disable-next-line:variable-name
export const TranslateServiceFactory = () => new TranslateService();

export const translateService = TranslateServiceFactory();
